import React from 'react';
import c from 'classnames';

import './style.scss';

const NavToggle = ({ onHamburgerClick, menuIsOpen }) => {
  const classNames = c('NavToggle icon-after', {
    'icon-menu': !menuIsOpen,
    'icon-close': menuIsOpen,
  });

  return (
    <div
      className={classNames}
      onClick={onHamburgerClick}
    >
      Menu
    </div>
  );
};

export default NavToggle;
